import BaseThemeProps from "src/themes/baseTheme/baseThemeProps";
import merge from "lodash/merge";
import get from "lodash/get";

export default class FlightThemeProps extends BaseThemeProps {
  getBreadcrumbsProps(theme) {
    const breadcrumbsTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.breadcrumbs")),
    };

    return {
      root: {
        fontFamily: breadcrumbsTheme.v2.typography.caption1.family,
        fontWeight: breadcrumbsTheme.v2.typography.caption1.weight,
        color: breadcrumbsTheme.v2.color.onSurface,
        textTransform: breadcrumbsTheme.v2.typography.caption1.textCase,
        fontSize: breadcrumbsTheme.v2.typography.caption1.size,
      },
      separator: {
        color: breadcrumbsTheme.v2.color.onSurface,
        fontWeight: breadcrumbsTheme.v2.typography.caption1.weight,
        fontSize: breadcrumbsTheme.v2.typography.caption1.size,
      },
    };
  }

  applyShadow(shadow) {
    return `${shadow[1]?.x}px ${shadow[1]?.y}px ${shadow[1]?.blur}px ${shadow[1]?.spread}px  ${shadow[1]?.color},
  ${shadow[0]?.x}px ${shadow[0]?.y}px ${shadow[0]?.blur}px ${shadow[0]?.spread}px ${shadow[0]?.color}`;
  }
  getHeaderProps(theme) {
    const headerTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.appBar")),
    };

    return {
      root: {
        backgroundColor: headerTheme.v2.color.surface,
        borderBottomColor: "transparent",
        borderWidth: headerTheme.v2.decoration.border.width.xs,
        boxShadow: this.applyShadow(theme.v2.decoration.shadow.s),
        fontFamily: headerTheme.v2.typography.bodyText1.family,
        color: headerTheme.v2.color.onSurface,
        fontWeight: headerTheme.v2.typography.bodyText1.weight,
        fontSize: headerTheme.v2.typography.bodyText1.size,
        letterSpacing: headerTheme.v2.typography.bodyText1.letterSpacing,
        textTransform: headerTheme.v2.typography.bodyText1.textCase,
      },
      logo: {
        maxWidth: {
          lg: "180px",
          md: "180px",
          sm: "120px",
        },
      },
    };
  }

  getHeaderLoginButtonProps(theme, options = {}) {
    return {
      outlineColor: theme.v2.color.secondary,
      borderRadius: theme.v2.decoration.border.radius.default,
      padding: options.loginText !== "login" ? "10px" : "8px 24px", // only used if outline/highlight is set to true
      highlightColor: theme.v2.color.primary,
    };
  }

  getHeaderSearchButtonProps(theme) {
    const searchButtonTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.appBar.searchButton")),
    };

    return {
      borderRadius: searchButtonTheme.v2.decoration.border.radius.default,
      outlineColor: searchButtonTheme.v2.color.secondary,
      color: searchButtonTheme.v2.color.onSurface,
      highlightColor: searchButtonTheme.v2.color.primary,
    };
  }

  getHeaderCartButtonProps(theme) {
    const cartButtonTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.appBar.cartButton")),
    };

    return {
      borderRadius: cartButtonTheme.v2.decoration.border.radius.default,
      highlightColor: cartButtonTheme.v2.color.primary,
      highlightTextColor: cartButtonTheme.v2.color.onPrimary,
      color: cartButtonTheme.v2.color.surface,
    };
  }

  getHeaderCartBadgeProps(theme) {
    const cartButtonTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.appBar.cartBadge")),
    };
    return {
      color: cartButtonTheme.v2.color.surface,
    };
  }

  getSidemenuProps(_theme) {
    const theme = {v2: merge({}, _theme.v2, get(_theme.v2, "overrides.sidemenu"))};

    return {
      root: {},
      options: {
        color: theme.v2.color.onSurface,
        fontFamily: theme.v2.typography.bodyText2.family,
        fontWeight: theme.v2.typography.bodyText2.weight,
        textTransform: theme.v2.typography.bodyText2.textCase,
        fontSize: {
          lg: theme.v2.typography.bodyText2.size.lg,
          md: theme.v2.typography.bodyText2.size.lg,
          sm: theme.v2.typography.bodyText2.size.lg,
        },
      },
    };
  }

  getDeliveryBannerProps(_theme) {
    const theme = {v2: merge({}, _theme.v2, get(_theme.v2, "overrides.deliveryBanner"))};

    return {
      root: {
        backgroundColor: theme.v2.color.secondary,
        color: theme.v2.color.typography.default,
        fontFamily: theme.v2.typography.title6.family,
        fontWeight: theme.v2.typography.title6.weight,
        fontSize: {
          lg: theme.v2.typography.title6.size.lg,
          md: theme.v2.typography.title6.size.lg,
          sm: theme.v2.typography.title6.size.md,
        },
      },
    };
  }

  getDeliveryModalProps(_theme) {
    const theme = {v2: merge({}, _theme.v2, get(_theme.v2, "overrides.deliveryModal"))};
    const deliveryDropdownTheme = {
      v2: merge({}, theme.v2, get(theme, "overrides.deliveryModal.deliveryDropdown")),
    };
    const typeSelectorTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.deliveryModal.typeSelector")),
    };
    const addressTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.deliveryModal.addressInput")),
    };
    const storeSelectorTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.deliveryModal.storeSelector")),
    };

    return {
      root: {
        backgroundColor: deliveryDropdownTheme.v2.color.background,
        borderRadius: "0 0 8px 8px",
        color: deliveryDropdownTheme.v2.color.onBackground,
      },
      typeSelector: {
        title: {
          color: typeSelectorTheme.v2.color.onBackground,
          fontFamily: typeSelectorTheme.v2.typography.title3.family,
          fontWeight: typeSelectorTheme.v2.typography.title3.weight,
          fontSize: {
            lg: typeSelectorTheme.v2.typography.title3.size.lg,
            md: typeSelectorTheme.v2.typography.title3.size.lg,
            sm: typeSelectorTheme.v2.typography.title3.size.md,
          },
        },
        options: {
          textShadowColor: "#f9d645",
          borderColor: typeSelectorTheme.v2.color.onBackground,
          color: typeSelectorTheme.v2.color.onBackground,
          fontFamily: typeSelectorTheme.v2.typography.bodyText2.family,
          fontWeight: typeSelectorTheme.v2.typography.bodyText2.weight,
          fontSize: {
            lg: typeSelectorTheme.v2.typography.bodyText2.size.lg,
            md: typeSelectorTheme.v2.typography.bodyText2.size.lg,
            sm: typeSelectorTheme.v2.typography.bodyText2.size.md,
          },
        },
      },
      addressInput: {
        title: {
          color: addressTheme.v2.color.onBackground,
          fontFamily: addressTheme.v2.typography.title3.family,
          fontWeight: addressTheme.v2.typography.title3.weight,
          fontSize: {
            lg: addressTheme.v2.typography.title3.size.lg,
            md: addressTheme.v2.typography.title3.size.lg,
            sm: addressTheme.v2.typography.title3.size.md,
          },
        },
        modeSelector: {
          mode: {
            borderColor: addressTheme.v2.color.onBackground,
            color: addressTheme.v2.color.onBackground,
            selectedColor: "#D8D8D8",
            fontFamily: addressTheme.v2.typography.bodyText1.family,
            fontWeight: addressTheme.v2.typography.bodyText1.weight,
            fontSize: {
              lg: addressTheme.v2.typography.bodyText1.size.lg,
              md: addressTheme.v2.typography.bodyText1.size.lg,
              sm: addressTheme.v2.typography.bodyText1.size.md,
            },
          },
          description: {
            color: "#7f7f7f",
            fontFamily: addressTheme.v2.typography.bodyText2.family,
            fontWeight: addressTheme.v2.typography.bodyText2.weight,
            fontSize: {
              lg: addressTheme.v2.typography.bodyText2.size.lg,
              md: addressTheme.v2.typography.bodyText2.size.lg,
              sm: addressTheme.v2.typography.bodyText2.size.md,
            },
          },
        },
      },
      storeSelector: {
        title: {
          color: storeSelectorTheme.v2.color.onBackground,
          fontFamily: storeSelectorTheme.v2.typography.title3.family,
          fontWeight: storeSelectorTheme.v2.typography.title3.weight,
          fontSize: {
            lg: storeSelectorTheme.v2.typography.title3.size.lg,
            md: storeSelectorTheme.v2.typography.title3.size.lg,
            sm: storeSelectorTheme.v2.typography.title3.size.md,
          },
        },
        options: {
          borderColor: storeSelectorTheme.v2.color.onBackground,
          color: storeSelectorTheme.v2.color.onBackground,
          selectedColor: "#D8D8D8",
          fontFamily: storeSelectorTheme.v2.typography.bodyText1.family,
          fontWeight: storeSelectorTheme.v2.typography.bodyText1.weight,
          fontSize: {
            lg: storeSelectorTheme.v2.typography.bodyText1.size.lg,
            md: storeSelectorTheme.v2.typography.bodyText1.size.lg,
            sm: storeSelectorTheme.v2.typography.bodyText1.size.md,
          },
        },
      },
    };
  }

  getCategoryBarProps(_theme, options = {}) {
    const theme = {v2: merge({}, _theme.v2, get(_theme.v2, "overrides.categoryBar"))};
    const categoryButtonTheme = {
      v2: merge(
        {
          spacing: {
            size: {
              xs: "8px",
              m: "16px",
            },
          },
        },
        theme.v2,
        get(theme, "v2.overrides.categoryBar.categoryButton")
      ),
    };
    const categoryImageTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.categoryBar.categoryImage")),
    };

    return {
      root: {
        scroll: {
          lg: false,
          md: false,
          sm: true,
        },
        backgroundColor: theme.v2.color.secondary,
        minHeight: {
          lg: "70px",
          md: "50px",
          sm: "50px",
        },
        columnGap: {
          lg: theme.v2.spacing("m"),
          md: theme.v2.spacing("xs"),
          sm: theme.v2.spacing("xs"),
        },
        padding: {
          lg: `${theme.v2.spacing("xs")} 0`,
          md: `${theme.v2.spacing("xs")} 0`,
          sm: `${theme.v2.spacing("xs")} 0`,
        },
      },
      button: {
        root: {
          fontFamily: categoryButtonTheme.v2.typography.title5.family,
          backgroundColor: categoryButtonTheme.v2.color.surface,
          color: categoryButtonTheme.v2.color.onSurface,
          selectedColor: categoryButtonTheme.v2.color.background,
          selectedBackgroundColor: categoryButtonTheme.v2.color.primary,
          fontWeight: categoryButtonTheme.v2.typography.title5.weight,
          padding: {
            lg: `${categoryButtonTheme.v2.spacing("xs")} ${categoryButtonTheme.v2.spacing(
              "xl"
            )}`,
            md: `${categoryButtonTheme.v2.spacing("xs")} ${categoryButtonTheme.v2.spacing(
              "xl"
            )}`,
            sm: `${categoryButtonTheme.v2.spacing("xs")} ${categoryButtonTheme.v2.spacing(
              "xl"
            )}`,
          },
          fontSize: {
            lg: categoryButtonTheme.v2.typography.title5.size.lg,
            md: categoryButtonTheme.v2.typography.title5.size.md,
            sm: categoryButtonTheme.v2.typography.title5.size.sm,
          },
          textTransform: categoryButtonTheme.v2.typography.title5.textCase,
          border: "none",
          borderRadius: categoryButtonTheme.v2.decoration.border.radius.default,
          height: {
            lg: "56px",
            md: "48px",
            sm: "48px",
          },
          boxShadow: options.buttonShadow
            ? this.applyShadow(categoryButtonTheme.v2.decoration.shadow.s)
            : "none",
        },
        image: {
          size: {
            lg: "44px",
            md: "36px",
            sm: "36px",
          },
          borderRadius: categoryImageTheme.v2.decoration.border.radius.default,
        },
      },
    };
  }

  getProductCardProps(_theme, props = {}) {
    const theme = {v2: merge({}, _theme.v2, _theme.v2.overrides.productCard)};
    const imageTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.productCard.image")),
    };
    const flowerTypeIndicatorTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.productCard.flowerTypeIndicator")),
    };
    const rootTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.productCard.card")),
    };
    const actionsTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.productCard.actions")),
    };
    const brandNameTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.productCard.brandName")),
    };
    const productNameTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.productCard.productName")),
    };
    const potencyTagTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.productCard.potencyTag")),
    };
    const priceTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.productCard.price")),
    };
    const sizesTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.productCard.sizes")),
    };
    const infoTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.productCard.info")),
    };

    const ifSmall = (small, otherwise) => (props.mode === "small" ? small : otherwise);

    return {
      root: {
        fontFamily: theme.v2.typography.bodyText1.family,
        border: `1px solid ${rootTheme.v2.color.border}`,
        padding: {
          lg: "16px",
          md: "16px",
          sm: props.isHorizontalInMobile && "8px 16px 8px 0",
        },
        hoverBorder: `${theme.v2.decoration.border.width.s} solid ${theme.v2.color.primary}`,
        borderRadius: rootTheme.v2.decoration.border.radius.default,
        boxShadow: this.applyShadow(theme.v2.decoration.shadow.m),
        onHoverBoxShadow: this.applyShadow(theme.v2.decoration.shadow.l),
        height: {
          lg: ifSmall("300px", "380px"),
          md: ifSmall("300px", "380px"),
          sm: props.isHorizontalInMobile ? "200px" : ifSmall("300px", "380px"),
        },
        maxWidth: {
          lg: "200px",
          md: "25vw",
          sm: props.isHorizontalInMobile ? "368px" : "245px",
        },
        minWidth: {
          lg: ifSmall("100%", "130px"),
          md: ifSmall("100%", "130px"),
          sm: props.isHorizontalInMobile ? "300px" : ifSmall("100%", "130px"),
        },
      },
      image: {
        borderBottom: "0",
        borderRadius: imageTheme.v2.decoration.border.radius.default,
        height: {
          lg: ifSmall("150px", "155px"),
          md: ifSmall("150px", "155px"),
          sm: props.isHorizontalInMobile ? "155px" : ifSmall("150px", "155px"),
        },
        minWidth: {
          sm: props.isHorizontalInMobile && "155px",
        },
        maxWidth: {
          sm: props.isHorizontalInMobile && "155px",
        },
        objectFit: "contain",
        padding: {
          lg: "16px",
          md: "16px",
          sm: props.isHorizontalInMobile ? "0" : "8px",
        },
      },
      promotionIndicator: {
        position: {
          top: "165px",
          left: "4px",
        },
      },
      flowerTypeIndicator: {
        fontWeight: flowerTypeIndicatorTheme.v2.typography.title6.weight,
        borderRadius: flowerTypeIndicatorTheme.v2.decoration.border.radius.default,
        padding: ifSmall("4px", "6px 8px"),
        fontSize: {
          lg: brandNameTheme.v2.typography.bodyText2.size.md,
          md: brandNameTheme.v2.typography.bodyText2.size.sm,
          sm: brandNameTheme.v2.typography.bodyText2.size.sm,
        },
        position: {
          left: ifSmall("-8px", "-20px"),
          top: props.isHorizontalInMobile ? "0px" : ifSmall("-8px", "20px"),
        },
        textTransform: "none",
      },
      saleIndicator: {
        fontWeight: flowerTypeIndicatorTheme.v2.typography.title6.weight,
        borderRadius: flowerTypeIndicatorTheme.v2.decoration.border.radius.default,
        fontFamily: flowerTypeIndicatorTheme.v2.typography.title6.family,
        backgroundColor: theme.v2.color.primary,
        fontSize: {
          lg: brandNameTheme.v2.typography.bodyText2.size.md,
          md: brandNameTheme.v2.typography.bodyText2.size.sm,
          sm: brandNameTheme.v2.typography.bodyText2.size.sm,
        },
        top: props.isHorizontalInMobile ? "30px" : ifSmall("2px 10px 0 15px", "0px"),
        margin: {
          lg: ifSmall("2px 10px 0 15px", "16px"),
          md: ifSmall("2px 10px 0 15px", "16px"),
          sm: ifSmall("2px 10px 0 15px", "16px"),
        },
      },
      info: {
        padding: {
          lg: ifSmall("8px", "16px 8px 24px 8px"),
          md: ifSmall("8px", "8px 8px 16px 8px"),
          sm: props.isHorizontalInMobile ? "0" : "8px",
        },
        childrenMarginBottom: {
          lg: infoTheme.v2.spacing.size?.xs,
          md: infoTheme.v2.spacing.size?.xs,
          sm: infoTheme.v2.spacing.size?.xs,
        },
      },
      brandName: {
        color: brandNameTheme.v2.color.typography.title6,
        fontFamily: brandNameTheme.v2.typography.title6.family,
        fontSize: {
          lg: brandNameTheme.v2.typography.title6.size.lg,
          md: brandNameTheme.v2.typography.title6.size.lg,
          sm: brandNameTheme.v2.typography.title6.size.lg,
        },
        fontWeight: brandNameTheme.v2.typography.title6.weight,
        textTransform: brandNameTheme.v2.typography.title6.textCase,
      },
      productName: {
        color: productNameTheme.v2.color.typography.bodyText2,
        fontFamily: productNameTheme.v2.typography.bodyText2.family,
        fontSize: {
          lg: productNameTheme.v2.typography.bodyText2.size.lg,
          md: productNameTheme.v2.typography.bodyText2.size.lg,
          sm: productNameTheme.v2.typography.bodyText2.size.lg,
        },
        fontWeight: productNameTheme.v2.typography.bodyText2.weight,
        textTransform: productNameTheme.v2.typography.bodyText2.textCase,
      },
      potencyTag: {
        fontFamily: potencyTagTheme.v2.typography.bodyText2.family,
        backgroundColor: potencyTagTheme.v2.color.secondary,
        border: 0,
        borderRadius: potencyTagTheme.v2.decoration.border.radius.default,
        fontSize: {
          lg: potencyTagTheme.v2.typography.bodyText2.size.lg,
          md: potencyTagTheme.v2.typography.bodyText2.size.lg,
          sm: potencyTagTheme.v2.typography.bodyText2.size.lg,
        },
        color: potencyTagTheme.v2.color.typography.bodyText2,
        padding: {
          lg: "0",
          md: "0",
          sm: "0",
        },
      },
      productSizes: {
        color: sizesTheme.v2.color.typography.caption1,
        fontFamily: sizesTheme.v2.typography.caption1.family,
        fontSize: {
          lg: sizesTheme.v2.typography.caption1.size.lg,
          md: sizesTheme.v2.typography.caption1.size.lg,
          sm: sizesTheme.v2.typography.caption1.size.lg,
        },
        fontWeight: sizesTheme.v2.typography.caption1.weight,
      },
      actionsContainer: {
        padding: {
          lg: ifSmall("8px", "0 8px 8px 8px"),
          md: ifSmall("8px", "0 8px 8px 8px"),
          sm: props.isHorizontalInMobile ? "0" : "0px 8px 8px 8px",
        },
      },
      actions: {
        root: {
          fontFamily: theme.v2.typography.title6.family,
          fontWeight: theme.v2.typography.title6.weight,
        },
        actions: {
          backgroundColor: theme.v2.color.primary,
          boxShadow: this.applyShadow(theme.v2.decoration.shadow.m),
          color: actionsTheme.v2.color.onPrimary,
          borderRadius: actionsTheme.v2.decoration.border.radius.default,
          height: {
            lg: "48px",
            md: "48px",
            sm: "48px",
          },
        },
        prices: {
          position: {
            lg: "left",
            md: "left",
            sm: "left",
          },
          crossed: {
            fontSize: {
              lg: actionsTheme.v2.typography.bodyText2.size.lg,
              md: actionsTheme.v2.typography.bodyText2.size.lg,
              sm: actionsTheme.v2.typography.bodyText2.size.lg,
            },
            fontWeight: actionsTheme.v2.typography.bodyText2.weight,
            color: ifSmall(
              actionsTheme.v2.color.primary,
              actionsTheme.v2.color.onBackground
            ),
          },
          alignment: "column",
          fontSize: {
            lg: priceTheme.v2.typography.title6.size.lg,
            md: priceTheme.v2.typography.title6.size.lg,
            sm: priceTheme.v2.typography.title6.size.sm,
          },
          fontWeight: priceTheme.v2.typography.title6.weight,
          color: ifSmall(
            actionsTheme.v2.color.primary,
            actionsTheme.v2.color.onBackground
          ),
          discountColor: actionsTheme.v2.color.secondaryVariant,
        },
      },
    };
  }

  getProductDetailProps(_theme, props = {}) {
    const theme = {v2: merge({}, _theme.v2, _theme.v2.overrides.productDetail)};
    const brandNameTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.productDetail.brandName")),
    };
    const productNameTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.productDetail.productName")),
    };
    const potencyTagTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.productDetail.potencyTag")),
    };
    const secondaryTagsTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.productDetail.secondaryTags")),
    };

    const flowerTypeIndicatorTheme = {
      v2: merge(
        {},
        theme.v2,
        get(theme, "v2.overrides.productDetail.flowerTypeIndicator")
      ),
    };
    const descriptionTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.productDetail.description")),
    };
    const priceDisplayTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.productDetail.priceDisplay")),
    };

    const quantityControllersTheme = {
      v2: merge(
        {},
        theme.v2,
        get(theme, "v2.overrides.productDetail.quantityControllers")
      ),
    };

    const navigationActionsTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.productDetail.navigationActions")),
    };

    const addToCartButtonTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.productDetail.addToCartButton")),
    };

    return {
      brand: {
        fontSize: {
          lg: get(brandNameTheme, "v2.typography.title6.size.lg"),
          md: get(brandNameTheme, "v2.typography.title6.size.lg"),
          sm: get(brandNameTheme, "v2.typography.title6.size.lg"),
        },
        fontWeight: get(brandNameTheme, "v2.typography.title6.weight"),
        color: get(brandNameTheme, "v2.color.typography.title6"),
        hoverTextDecoration: get(brandNameTheme, "v2.text.decorations.underline"),
        textTransform: get(brandNameTheme, "v2.typography.title6.textCase"),
      },
      name: {
        fontFamily: get(productNameTheme, "v2.typography.title2.family"),
        fontSize: {
          lg: get(productNameTheme, "v2.typography.title2.size.lg"),
          md: get(productNameTheme, "v2.typography.title2.size.lg"),
          sm: get(productNameTheme, "v2.typography.title2.size.md"),
        },
        fontWeight: get(productNameTheme, "v2.typography.title2.weight"),
        color: get(productNameTheme, "v2.color.onSurface"),
        textTransform: get(productNameTheme, "v2.typography.title2.textCase"),
      },
      mainTagsContainer: {
        columnGap: "10px",
        margin: "10px 0 0 0",
      },
      promotionIndicator: {
        position: {
          left: "220px",
        },
      },
      flowerTypeIndicator: {
        position: {
          lg: {
            top: "16px",
            left: "-20px",
          },
          md: {
            top: "16px",
            left: "-20px",
          },
          sm: {
            top: "16px",
            left: "-20px",
          },
        },
        border: "none",
        borderRadius: get(
          flowerTypeIndicatorTheme,
          "v2.decoration.border.radius.default"
        ),
        fontSize: {
          lg: get(flowerTypeIndicatorTheme, "v2.typography.bodyText1.size.lg"),
          md: get(flowerTypeIndicatorTheme, "v2.typography.bodyText1.size.lg"),
          sm: get(flowerTypeIndicatorTheme, "v2.typography.bodyText1.size.md"),
        },
        fontWeight: get(flowerTypeIndicatorTheme, "v2.typography.bodyText1.weight"),
      },
      mainTags: {
        padding: {
          lg: "4px 0px 0px 4px",
          md: "4px 0px 0px 4px",
          sm: "4px 0px 0px 4px",
        },
        border: "none",
        borderRadius: get(potencyTagTheme, "v2.decoration.border.radius.default"),
        backgroundColor: get(potencyTagTheme, "v2.color.secondary"),
        fontSize: {
          lg: get(potencyTagTheme, "v2.typography.bodyText2.size.lg"),
          md: get(potencyTagTheme, "v2.typography.bodyText2.size.lg"),
          sm: get(potencyTagTheme, "v2.typography.bodyText2.size.md"),
        },
        fontFamily: get(potencyTagTheme, "v2.typography.bodyText2.family"),
        fontWeight: get(potencyTagTheme, "v2.typography.bodyText2.weight"),
        color: get(potencyTagTheme, "v2.color.typography.bodyText2"),
      },
      description: {
        root: {
          margin: "6px 0",
          fontFamily: get(descriptionTheme, "v2.typography.bodyText1.family"),
          lineHeight: {
            lg: get(descriptionTheme, "v2.typography.bodyText1.lineHeight"),
            md: get(descriptionTheme, "v2.typography.bodyText1.lineHeight"),
            sm: get(descriptionTheme, "v2.typography.bodyText1.lineHeight"),
          },
        },
        text: {
          fontSize: {
            lg: get(descriptionTheme, "v2.typography.bodyText1.size.lg"),
            md: get(descriptionTheme, "v2.typography.bodyText1.size.lg"),
            sm: get(descriptionTheme, "v2.typography.bodyText1.size.lg"),
          },
          fontWeight: get(descriptionTheme, "v2.typography.bodyText1.weight"),
          color: get(descriptionTheme, "v2.color.base.grey.800"),
        },
        button: {
          fontSize: {
            lg: get(descriptionTheme, "v2.typography.title6.size.lg"),
            md: get(descriptionTheme, "v2.typography.title6.size.lg"),
            sm: get(descriptionTheme, "v2.typography.title6.size.lg"),
          },
          fontWeight: get(descriptionTheme, "v2.typography.title6.weight"),
          color: get(descriptionTheme, "v2.color.base.grey.800"),
        },
      },
      priceDisplay: {
        price: {
          fontSize: {
            lg: get(priceDisplayTheme, "v2.typography.title5.size.lg"),
            md: get(priceDisplayTheme, "v2.typography.title5.size.lg"),
            sm: get(priceDisplayTheme, "v2.typography.title5.size.lg"),
          },
          fontWeight: get(priceDisplayTheme, "v2.typography.title5.weight"),
          color: get(priceDisplayTheme, "v2.color.onSurface"),
        },
        size: {
          fontSize: {
            lg: get(priceDisplayTheme, "v2.typography.bodyText1.size.lg"),
            md: get(priceDisplayTheme, "v2.typography.bodyText1.size.lg"),
            sm: get(priceDisplayTheme, "v2.typography.bodyText1.size.lg"),
          },
          fontWeight: get(priceDisplayTheme, "v2.typography.bodyText1.weight"),
          color: get(priceDisplayTheme, "v2.color.base.grey.600"),
        },
        pricePerUnit: {
          fontSize: {
            lg: get(priceDisplayTheme, "v2.typography.caption1.size.lg"),
            md: get(priceDisplayTheme, "v2.typography.caption1.size.lg"),
            sm: get(priceDisplayTheme, "v2.typography.caption1.size.lg"),
          },
          fontWeight: get(priceDisplayTheme, "v2.typography.caption1.weight"),
          color: get(priceDisplayTheme, "v2.color.onSurface"),
        },
      },
      quantityPicker: {
        root: {
          flexDirection: {
            sm: "column",
          },
          alignItems: {
            sm: "flex-start",
          },
          width: {
            sm: "100%",
          },
          padding: {
            sm: `0`,
          },
        },
        quantityPicker: {
          borderRadius: get(
            quantityControllersTheme,
            "v2.decoration.border.radius.default"
          ),
          backgroundColor: get(quantityControllersTheme, "v2.color.base.grey.200"),
          quantityColor: get(quantityControllersTheme, "v2.color.onSurface"),
          controllersColor: get(quantityControllersTheme, "v2.color.onSurface"),
          quantitySize: get(quantityControllersTheme, "v2.typography.title4.size"),
          controllersWidth: {
            lg: get(quantityControllersTheme, "v2.static.spacing.size.xl"),
            md: get(quantityControllersTheme, "v2.static.spacing.size.xl"),
            sm: get(quantityControllersTheme, "v2.static.spacing.size.xl"),
          },
          controllersHeight: {
            lg: get(quantityControllersTheme, "v2.static.spacing.size.xl"),
            md: get(quantityControllersTheme, "v2.static.spacing.size.xl"),
            sm: get(quantityControllersTheme, "v2.static.spacing.size.xl"),
          },
          minusIconSize: get(quantityControllersTheme, "v2.static.spacing.size.xl"),
          plusIconSize: get(quantityControllersTheme, "v2.static.spacing.size.xl"),
          removeItemIcon: {
            color: get(quantityControllersTheme, "v2.color.onSurface"),
          },
        },
        addToCartButton: {
          backgroundColor: get(addToCartButtonTheme, "v2.color.primary"),
          color: get(addToCartButtonTheme, "v2.color.onPrimary"),
          borderRadius: get(addToCartButtonTheme, "v2.decoration.border.radius.default"),
          fontSize: get(addToCartButtonTheme, "v2.typography.title5.size"),
          fontWeight: get(addToCartButtonTheme, "v2.typography.title5.weight"),
          mobileMaxHeight: "55px",
          width: {
            lg: "220px",
            sm: "100%",
          },
        },
        weightSelector: {
          marginTop: {
            lg: "16px",
            sm: "6px",
          },
        },
      },
      secondaryTags: {
        backgroundColor: get(secondaryTagsTheme, "v2.color.base.grey.300"),
        color: get(secondaryTagsTheme, "v2.color.base.grey.900"),
        borderRadius: theme.v2.decoration.border.radius.xl,
        fontSize: {
          lg: get(secondaryTagsTheme, "v2.typography.caption1.size.lg"),
          md: get(secondaryTagsTheme, "v2.typography.caption1.size.lg"),
          sm: get(secondaryTagsTheme, "v2.typography.caption1.size.lg"),
        },
        fontWeight: get(secondaryTagsTheme, "v2.typography.caption1.weight"),
        textTransform: get(theme, "v2.text.case.capitalize"),
        padding: {
          lg: `${get(theme, "v2.static.spacing.size.xs")} ${get(
            theme,
            "v2.static.spacing.size.s"
          )}`,
          md: `${get(theme, "v2.static.spacing.size.xs")} ${get(
            theme,
            "v2.static.spacing.size.s"
          )}`,
          sm: `${get(theme, "v2.static.spacing.size.xs")} ${get(
            theme,
            "v2.static.spacing.size.s"
          )}`,
        },
      },
      navigationActions: {
        root: {
          padding: "0 16px",
        },
        backButton: {
          backgroundColor: navigationActionsTheme.v2.color.base.grey["400"],
          color: navigationActionsTheme.v2.color.base.grey["900"],
          borderRadius: navigationActionsTheme.v2.decoration.border.radius.default,
          fontWeight: navigationActionsTheme.v2.typography.title5.weight,
        },
        cartButton: {
          backgroundColor: navigationActionsTheme.v2.color.primary,
          color: navigationActionsTheme.v2.color.onPrimary,
          borderRadius: navigationActionsTheme.v2.decoration.border.radius.default,
          fontWeight: navigationActionsTheme.v2.typography.title5.weight,
        },
      },
    };
  }

  getProductDetailSeparatorProps(_theme) {
    const theme = {
      v2: merge({}, _theme.v2, _theme.v2.overrides.productDetail?.separator),
    };

    return {
      backgroundColor: theme.v2.color.base.grey["200"],
    };
  }

  getProductListProps(_theme, site) {
    // const theme = {v2: merge({}, _theme.v2, _theme.v2.overrides.productList)};

    return {
      root: {
        elementsPerRow: {
          lg: site.getUiConfiguration().productsList.productsPerLine.lg,
          md: site.getUiConfiguration().productsList.productsPerLine.md,
          sm: 1,
        },
        padding: {
          lg: "0px",
          md: "0px",
          sm: "0px",
        },
      },
      element: {},
    };
  }

  getNoResultsPlaceholderProps(theme) {
    return {
      root: {
        padding: {
          lg: "24px 8px",
          md: "24px 8px",
          sm: "24px 8px",
        },
      },
      logo: {
        backgroundColor: theme.v2.color.primary,
        borderRadius: theme.v2.decoration.border.radius.default,
      },
      titleText: {
        fontFamily: theme.v2.typography.title1.family,
        color: theme.v2.color.onBackground,
        fontSize: theme.v2.typography.sizing.l,
      },
      detailText: {
        fontFamily: theme.v2.typography.bodyText1.family,
        color: theme.v2.color.onBackground,
        fontSize: theme.v2.typography.sizing.m,
      },
    };
  }

  getShowcasedProductListProps(_theme) {
    const theme = {v2: merge({}, _theme.v2, _theme.v2.overrides.showcasedProductsList)};

    return {
      list: {
        justifyContent: "flex-start",
        padding: "14px 16px 42px 20px",
        flexDirection: {
          lg: "row",
          md: "row",
          sm: "column",
        },
      },
      element: {
        maxWidth: {
          lg: "320px",
          md: "250px",
          sm: "368px",
        },
        minWidth: {
          lg: "150px",
          md: "140px",
          sm: "300px",
        },
      },
      header: {
        fontFamily: theme.v2.typography.title1.family,
        color: theme.v2.color.primary,
        lineColor: theme.v2.color.base.grey["300"],
        fontWeight: theme.v2.typography.title1.weight,
        fontSize: {
          sm: theme.v2.typography.sizing["3xl"].lg,
          md: theme.v2.typography.sizing["4xl"].lg,
          lg: theme.v2.typography.sizing["4xl"].lg,
        },
      },
      indicator: {
        indicator: {
          color: theme.v2.color.primary,
        },
      },
      navigationButton: {
        root: {
          width: "41px",
          height: "41px",
          backgroundColor: "#ffffff",
          color: "#000000",
          borderRadius: "50%",
          border: "1px solid #a8a8a8",
          boxShadow: "0 0 8.78294px 0.878294px #E8E8E8",
        },
      },
    };
  }

  getAppliedFiltersListProps(_theme) {
    const theme = {v2: merge({}, _theme.v2, _theme.v2.overrides?.appliedFilters)};

    return {
      root: {
        margin: `0 ${theme.v2.spacing(4)} ${theme.v2.spacing(1)} 0`,
      },
      container: {
        backgroundColor: theme.v2.color.secondary,
        color: theme.v2.color.onSecondary,
      },
      text: {
        fontFamily: theme.v2.typography.bodyText1.family,
        fontSize: {
          lg: theme.v2.typography.bodyText1.size.lg,
          md: theme.v2.typography.bodyText1.size.md,
          sm: theme.v2.typography.bodyText1.size.sm,
        },
        fontWeight: theme.v2.typography.bodyText1.weight,
      },
    };
  }

  getSortFiltersProps(_theme, options = {}) {
    const theme = {v2: merge({}, _theme.v2, get(_theme.v2, "overrides.sortFilters"))};
    const optionsTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.sortFilters.options")),
    };

    return {
      root: {
        padding: {
          lg: `0 0 ${theme.v2.spacing(8)} ${theme.v2.spacing(8)}`,
          md: `0 0 ${theme.v2.spacing(4)} ${theme.v2.spacing(4)}`,
        },
      },
      sort: {
        root: {
          width: {
            lg: "230px",
            sm: "190px",
          },
          control: {
            borderColor: theme.v2.color.border,
            borderRadius: theme.v2.decoration.border.radius.default,
            borderWidth: {
              lg: "1px",
              md: "1px",
              sm: options.withBorder?.sm ? "1px" : "0",
            },
            color: theme.v2.color.onSurface,
            backgroundColor: theme.v2.color.surface,
            fontFamily: theme.v2.typography.title5.family,
            fontSize: {
              lg: theme.v2.typography.title5.size.md,
            },
            fontWeight: theme.v2.typography.title5.weight,
            lineHeight: theme.v2.typography.title5.lineHeight,
            hover: {
              borderColor: theme.v2.color.primary,
            },
          },
          menu: {
            borderRadius: theme.v2.decoration.border.radius.default,
            backgroundColor: theme.v2.color.surface,
            borderColor: theme.v2.color.border,
            margin: `${theme.v2.static.spacing.size.xs} 0`,
          },
          options: {
            color: theme.v2.color.onBackground,
            fontFamily: optionsTheme.v2.typography.title5.family,
            fontSize: {
              lg: optionsTheme.v2.typography.title5.size.md,
            },
            fontWeight: optionsTheme.v2.typography.title5.weight,
            hover: {
              backgroundColor: optionsTheme.v2.color.secondary,
              color: optionsTheme.v2.color.onSurface,
            },
            selected: {
              backgroundColor: optionsTheme.v2.color.secondary,
              color: optionsTheme.v2.color.onSurface,
            },
          },
          arrow: {
            borderColor: `${theme.v2.color.onSurface} transparent transparent`,
            open: {
              borderColor: `transparent transparent ${theme.v2.color.onSurface}`,
            },
          },
        },
      },
      filters: {
        button: {
          root: {
            fontFamily: theme.v2.typography.title5.family,
            fontSize: theme.v2.typography.title5.size.md,
            borderRadius: theme.v2.decoration.border.radius.default,
            border: {
              lg: `1px solid ${theme.v2.color.border}`,
              md: `1px solid ${theme.v2.color.border}`,
              sm: options.withBorder?.sm ? `1px solid ${theme.v2.color.border}` : "0",
            },
            fontWeight: theme.v2.typography.title5.weight,
            hoverBorderColor: theme.v2.color.primary,
            boxShadow: {
              sm: "0 0 20px -5px rgba(0, 0, 0, 0.2)",
            },
          },
          secondary: {
            backgroundColor: theme.v2.color.surface,
            color: theme.v2.color.onSurface,
          },
        },
      },
    };
  }

  getFooterProps(_theme) {
    const theme = {v2: merge({}, _theme.v2, _theme.v2.overrides.footer)};
    return {
      root: {
        backgroundColor: theme.v2.color.base.grey["50"],
      },
      element: {
        hoverLinkColor: theme.v2.color.primary,
        activeLinkColor: theme.v2.color.primary,
        fontFamily: theme.v2.typography.primary.family,
        color: theme.v2.color.onBackground,
      },
    };
  }

  getRecommendedListProps(theme) {
    return {
      list: {justifyContent: "flex-start"},
      element: {
        maxWidth: {
          lg: "250px",
          md: "250px",
          sm: "360px",
        },
        minWidth: {
          lg: "150px",
          md: "150px",
          sm: "150px",
        },
      },
      header: {},
      indicator: {
        indicator: {
          color: theme.v2.color.primaryVariant,
        },
      },
      navigationButton: {
        root: {},
      },
    };
  }

  getBrandHeaderProps(_theme) {
    const theme = {v2: merge({}, _theme.v2, get(_theme, "v2.overrides.title"))};
    const titleTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.title")),
    };
    return {
      fontFamily: titleTheme.v2.typography.title1.family,
      fontSize: {
        sm: titleTheme.v2.typography.sizing["3xl"].lg,
        md: titleTheme.v2.typography.sizing["4xl"].lg,
        lg: titleTheme.v2.typography.sizing["4xl"].lg,
      },
      letterSpacing: {
        sm: titleTheme.v2.typography.title1.letterSpacing,
        md: titleTheme.v2.typography.title1.letterSpacing,
        lg: titleTheme.v2.typography.title1.letterSpacing,
      },
      fontWeight: titleTheme.v2.typography.primary.weight.heavy,
      color: titleTheme.v2.color.typography.title1,
      margin: 0,
      padding: 0,
      textTransform: "none",
      backgroundColor: "transparent",

      "> span": ` {
      cursor: default;
      font-family: ${titleTheme.v2.typography.body.family};
  
      &:hover {
        text-decoration: none;
      }
    }`,
    };
  }
  getProductRecommendationsProps() {
    return {
      element: {
        minWidth: {
          lg: "180px",
          md: "180px",
          sm: "180px",
        },
        maxWidth: {
          lg: "180px",
          md: "180px",
          sm: "180px",
        },
      },
    };
  }

  getFiltersPanelProps(_theme) {
    const theme = {v2: merge({}, _theme.v2, _theme.v2.overrides.filtersPanel)};

    return {
      root: {
        backgroundColor: theme.v2.color.background,
        width: {
          lg: "180px",
          sm: "100%",
        },
        minWidth: {
          lg: "180px",
          sm: "180px",
        },
        padding: {
          lg: "0px",
          sm: "0px",
        },
      },
      header: {
        margin: {
          lg: "10px 0 20px",
          sm: "10px 0 20px",
        },
        fontFamily: theme.v2.typography.title2.family,
        fontSize: theme.v2.typography.title2.size,
        fontWeight: theme.v2.typography.title2.weight,
      },
      clearFilters: {
        fontFamily: theme.v2.typography.bodyText1.family,
      },
      separator: {
        color: theme.v2.color.base.grey["200"],
        height: "2px",
      },
      filterGroup: {
        header: {
          margin: {
            lg: "10px 0",
            sm: "10px 0",
          },
          fontFamily: theme.v2.typography.title5.family,
          fontSize: theme.v2.typography.title5.size,
          fontWeight: theme.v2.typography.title5.weight,
        },
        onSale: {
          label: {
            fontFamily: theme.v2.typography.bodyText2.family,
            fontSize: theme.v2.typography.bodyText2.size,
            fontWeight: theme.v2.typography.bodyText2.weight,
          },
        },
        showMore: {
          fontFamily: theme.v2.typography.bodyText2.family,
          fontSize: theme.v2.typography.bodyText2.size,
          fontWeight: theme.v2.typography.bodyText2.weight,
        },
        options: {
          root: {
            margin: {
              lg: "0 0 10px",
              sm: "0 0 10px",
            },
            padding: {
              lg: "0",
              sm: "0",
            },
            fontFamily: theme.v2.typography.bodyText2.family,
            fontSize: theme.v2.typography.bodyText2.size,
            fontWeight: theme.v2.typography.bodyText2.weight,
          },
        },
        separator: {
          color: theme.v2.color.base.grey["200"],
          height: "2px",
        },
      },
    };
  }

  getProductFiltersProps(_theme) {
    const theme = {v2: merge({}, _theme.v2, _theme.v2.overrides.productFilters)};
    const titleTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.productFilters.title")),
    };
    const counterTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.productFilters.counter")),
    };
    const sectionTheme = {
      v2: merge({}, theme.v2, get(theme, "v2.overrides.productFilters.section")),
    };

    return {
      title: {
        backgroundColor: titleTheme.v2.color.background,
        color: titleTheme.v2.color.onBackground,
      },
      counter: {
        color: counterTheme.v2.color.onSurface,
      },
      section: {
        color: sectionTheme.v2.color.onSurface,
        separatorColor: sectionTheme.v2.color.base.grey[300],
        separatorWidth: "1px",
        checkmarkColor: sectionTheme.v2.color.onBackground,
      },
    };
  }
  getCheckoutHeaderProps(_theme) {
    const theme = {v2: merge({}, _theme.v2, _theme.v2.overrides.checkoutHeader)};

    return {
      root: {
        padding: {
          lg: `${theme.v2.spacing(2)} ${theme.v2.spacing(4)}`,
          md: `${theme.v2.spacing(1)} ${theme.v2.spacing(2)}`,
          sm: `${theme.v2.spacing(1)} ${theme.v2.spacing(2)}`,
        },
      },
      backButton: {
        fontFamily: theme.v2.typography.title6.family,
        fontWeight: theme.v2.typography.title6.weight,
        fontSize: theme.v2.typography.title6.size,
        color: theme.v2.color.typography.title6,
        border: `${theme.v2.decoration.border.width.xs} solid ${theme.v2.color.base.grey["900"]}`,
        borderRadius: theme.v2.decoration.border.radius.xxs,
      },
    };
  }

  getCheckoutOrderSummaryProps(_theme) {
    const theme = {v2: merge({}, _theme.v2, _theme.v2.overrides.checkoutOrderSummary)};

    return {
      expandableArea: {
        container: {
          background: theme.v2.color.base.grey["100"],
          width: {
            lg: "100%",
            md: "100%",
            sm: "100%",
          },
          padding: {
            sm: "0",
            md: theme.v2.static.spacing.size["3xl"],
            lg: theme.v2.static.spacing.size["3xl"],
          },
          contentMaxWidth: {
            sm: "768px",
            md: "420px",
            lg: "420px",
          },
        },
        expandableContent: {
          padding: {
            sm: theme.v2.static.spacing.size.m,
            md: theme.v2.static.spacing.size.m,
            lg: theme.v2.static.spacing.size.m,
          },
        },
      },
      divider: {
        height: theme.v2.decoration.border.width.xs,
        background: theme.v2.color.base.grey["300"],
        margin: {
          sm: `${theme.v2.static.spacing.size.l} 0px`,
          md: `${theme.v2.static.spacing.size.l} 0px`,
          lg: `${theme.v2.static.spacing.size.l} 0px`,
        },
      },
    };
  }

  getCheckoutMobileHeaderProps(_theme) {
    const theme = {v2: merge({}, _theme.v2, _theme.v2.overrides.checkoutMobileHeader)};

    return {
      container: {
        background: theme.v2.color.base.grey["100"],
        borderBottom: `${theme.v2.decoration.border.width.xs} solid ${theme.v2.color.base.grey["300"]}`,
        padding: theme.v2.static.spacing.size.m,
        gap: theme.v2.static.spacing.size.xs,
      },
      title: {
        fontFamily: theme.v2.typography.title6.family,
        fontSize: theme.v2.typography.title6.size.sm,
        fontWeight: theme.v2.typography.title6.weight,
        fontStyle: "normal",
        color: theme.v2.color.typography.title6,
      },
      totalPrice: {
        fontFamily: theme.v2.typography.title4.family,
        fontSize: theme.v2.typography.title4.size.sm,
        fontStyle: "normal",
        color: theme.v2.color.typography.title4,
        letterSpacing: "-0.2px",
        lineHeight: theme.v2.typography.title4.lineHeight,
      },
    };
  }

  getCheckoutProductSectionProps(_theme) {
    const theme = {v2: merge({}, _theme.v2, _theme.v2.overrides.checkoutProductSection)};

    return {
      productSectionContainer: {
        gap: {
          sm: theme.v2.static.spacing.size.m,
          md: theme.v2.static.spacing.size.m,
          lg: theme.v2.static.spacing.size.m,
        },
      },
      emptyCart: {
        fontFamily: theme.v2.typography.title4.family,
        fontSize: {
          sm: theme.v2.typography.title4.size.sm,
          md: theme.v2.typography.title4.size.md,
          lg: theme.v2.typography.title4.size.lg,
        },
        fontWeight: theme.v2.typography.fontWeight,
        color: theme.v2.color.base.grey["600"],
        padding: {
          sm: `${theme.v2.static.spacing.size.l} 0px ${theme.v2.static.spacing.size.m} 0px`,
          md: `${theme.v2.static.spacing.size.l} 0px ${theme.v2.static.spacing.size.m} 0px`,
          lg: `${theme.v2.static.spacing.size.l} 0px ${theme.v2.static.spacing.size.m} 0px`,
        },
      },
      productItem: {
        container: {
          gap: theme.v2.static.spacing.size.m,
        },
        productImageContainer: {
          border: `${theme.v2.decoration.border.width.xs} solid ${theme.v2.color.base.grey["300"]}`,
          borderRadius: theme.v2.decoration.border.radius.xxs,
        },
        productImage: {
          borderRadius: theme.v2.decoration.border.radius.xxs,
        },
        itemQuantity: {
          background: theme.v2.color.base.grey["100"],
          borderRadius: theme.v2.decoration.border.radius.xxs,
          color: theme.v2.color.base.grey["600"],
          quantityColor: theme.v2.color.base.grey["900"],
          fontFamily: theme.v2.typography.caption1.family,
          fontWeight: theme.v2.typography.caption1.weight,
          fontSize: theme.v2.typography.caption1.size,
          lineHeight: theme.v2.typography.caption1.lineHeight,
        },
        brandName: {
          color: theme.v2.color.typography.caption1,
          fontFamily: theme.v2.typography.caption1.family,
          fontWeight: theme.v2.typography.caption1.weight,
          fontSize: theme.v2.typography.caption1.size,
          lineHeight: theme.v2.typography.caption1.lineHeight,
        },
        errorMessage: {
          color: theme.v2.color.error,
          fontFamily: theme.v2.typography.caption1.family,
          fontWeight: theme.v2.typography.caption1.weight,
          fontSize: theme.v2.typography.caption1.size,
          lineHeight: theme.v2.typography.caption1.lineHeight,
        },
        productName: {
          color: theme.v2.color.typography.bodyText2,
          fontFamily: theme.v2.typography.bodyText2.family,
          fontWeight: theme.v2.typography.bodyText2.weight,
          fontSize: theme.v2.typography.bodyText2.size,
          lineHeight: theme.v2.typography.bodyText2.lineHeight,
        },
        productSize: {
          color: theme.v2.color.typography.caption1,
          fontFamily: theme.v2.typography.caption1.family,
          fontWeight: theme.v2.typography.caption1.weight,
          fontSize: theme.v2.typography.caption1.size,
          lineHeight: theme.v2.typography.caption1.lineHeight,
          gap: theme.v2.static.spacing.size.xs,
        },
        removeButton: {
          marginLeft: theme.v2.static.spacing.size.xs,
          color: theme.v2.color.typography.bodyText1,
          fontFamily: theme.v2.typography.caption1.family,
          fontWeight: theme.v2.typography.caption1.weight,
          fontSize: theme.v2.typography.caption1,
          lineHeight: theme.v2.typography.caption1.lineHeight,
          hover: {
            textDecoration: theme.v2.text.decorations.underline,
          },
        },
        productPrice: {
          color: theme.v2.color.typography.bodyText2,
          fontFamily: theme.v2.typography.bodyText2.family,
          fontWeight: theme.v2.typography.bodyText2.weight,
          fontSize: theme.v2.typography.bodyText2.size,
          lineHeight: theme.v2.typography.bodyText2.lineHeight,
          crossed: {
            color: theme.v2.color.typography.caption1,
            fontFamily: theme.v2.typography.caption1.family,
            fontWeight: theme.v2.typography.caption1.weight,
            fontSize: theme.v2.typography.caption1.size,
            lineHeight: theme.v2.typography.caption1.lineHeight,
          },
        },
        productDiscountedPrice: {
          color: theme.v2.color.typography.bodyText2,
          fontFamily: theme.v2.typography.bodyText2.family,
          fontWeight: theme.v2.typography.bodyText2.weight,
          fontSize: theme.v2.typography.bodyText2.size,
          lineHeight: theme.v2.typography.bodyText2.lineHeight,
        },
      },
    };
  }

  getCheckouTotalSectionProps(_theme) {
    const theme = {v2: merge({}, _theme.v2, _theme.v2.overrides.checkoutTotalSection)};
    return {
      container: {
        gap: "12px",
      },
      label: {
        color: theme.v2.color.base.grey["800"],
        fontFamily: theme.v2.typography.bodyText2.family,
        fontSize: theme.v2.typography.bodyText2.size,
        fontWeight: theme.v2.typography.bodyText2.weight,
        fontStyle: "normal",
        lineHeight: theme.v2.typography.bodyText2.lineHeight,
      },
      sublabel: {
        fontFamily: theme.v2.typography.bodyText2.family,
        fontSize: theme.v2.typography.bodyText2.size,
        fontWeight: theme.v2.typography.bodyText2.weight,
        color: theme.v2.color.base.grey["600"],
      },
      groupLabel: {
        color: theme.v2.color.base.grey["800"],
        fontFamily: theme.v2.typography.bodyText2.family,
        fontSize: theme.v2.typography.bodyText2.size,
        fontWeight: theme.v2.typography.bodyText2.weight,
        fontStyle: "normal",
        lineHeight: theme.v2.typography.bodyText2.lineHeight,
      },
      discountCode: {
        fontFamily: theme.v2.typography.titles.family,
        fontSize: theme.v2.typography.bodyText2.size,
        fontWeight: theme.v2.typography.bodyText2.weight,
        fontStyle: "normal",
        color: theme.v2.color.typography.caption1,
        lineHeight: theme.v2.typography.bodyText2.lineHeight,
        letterSpacing: "-0.2px",
        textTransform: theme.v2.text.case.uppercase,
      },
      price: {
        color: theme.v2.color.base.grey["800"],
        fontFamily: theme.v2.typography.bodyText2.family,
        fontSize: theme.v2.typography.bodyText2.size,
        fontWeight: theme.v2.typography.bodyText2.weight,
        fontStyle: "normal",
        lineHeight: theme.v2.typography.bodyText2.lineHeight,
      },
      totalLabel: {
        color: theme.v2.color.typography.title6,
        fontFamily: theme.v2.typography.title6.family,
        fontSize: theme.v2.typography.title6.size,
        fontWeight: theme.v2.typography.title6.weight,
        fontStyle: "normal",
        lineHeight: theme.v2.typography.title6.lineHeight,
      },
      totalCurrency: {
        fontFamily: theme.v2.typography.caption1.family,
        fontSize: theme.v2.typography.caption1.size,
        fontWeight: theme.v2.typography.caption1.weight,
        fontStyle: "normal",
        color: theme.v2.color.typography.caption1,
        lineHeight: theme.v2.typography.caption1.lineHeight,
      },
      totalValue: {
        fontFamily: theme.v2.typography.title3.family,
        fontSize: theme.v2.typography.title3.size,
        fontWeight: theme.v2.typography.titles.weight.heavy,
        fontStyle: "normal",
        color: theme.v2.color.typography.title3,
        lineHeight: theme.v2.typography.title3.lineHeight,
        letterSpacing: theme.v2.typography.caption1.letterSpacing,
      },
    };
  }

  getCheckoutPromoCodeSectionProps(_theme) {
    const theme = {
      v2: merge({}, _theme.v2, _theme.v2.overrides.checkoutPromoCodeSection),
    };

    return {
      inputRow: {
        gap: {
          lg: theme.v2.static.spacing.size.m,
          md: theme.v2.static.spacing.size.m,
          sm: theme.v2.static.spacing.size.m,
        },
      },
      promotionRow: {
        gap: {
          lg: theme.v2.static.spacing.size.m,
          md: theme.v2.static.spacing.size.m,
          sm: theme.v2.static.spacing.size.m,
        },
        padding: {
          lg: `${theme.v2.static.spacing.size.m} 0px 0px 0px`,
          md: `${theme.v2.static.spacing.size.m} 0px 0px 0px`,
          sm: `${theme.v2.static.spacing.size.m} 0px 0px 0px`,
        },
      },
      input: {
        fontFamily: theme.v2.typography.bodyText2.family,
        fontSize: theme.v2.typography.bodyText2.size,
        background: theme.v2.color.background,
        border: `${theme.v2.decoration.border.width.xs} solid ${theme.v2.color.base.grey["300"]}`,
        borderRadius: theme.v2.decoration.border.radius.xxs,
        placeholderColor: theme.v2.color.typography.caption1,
        padding: {
          lg: theme.v2.static.spacing.size.s,
          md: theme.v2.static.spacing.size.s,
          sm: theme.v2.static.spacing.size.s,
        },
        hover: {
          borderColor: theme.v2.color.base.grey["400"],
        },
        error: {
          border: `${theme.v2.decoration.border.width.xs} solid ${theme.v2.color.error}`,
          placeholderColor: theme.v2.color.error,
        },
        disabled: {
          background: theme.v2.color.base.grey["100"],
          border: `${theme.v2.decoration.border.width.xs} solid ${theme.v2.color.base.grey["300"]}`,
        },
      },
      button: {
        root: {
          fontSize: theme.v2.typography.bodyText2.size,
        },
      },
      promoTag: {
        container: {
          background: theme.v2.color.base.grey["200"],
          border: "none",
          borderRadius: theme.v2.decoration.border.radius.xxs,
          padding: {
            lg: `${theme.v2.static.spacing.size.xs} ${theme.v2.static.spacing.size.s}`,
            md: `${theme.v2.static.spacing.size.xs} ${theme.v2.static.spacing.size.s}`,
            sm: `${theme.v2.static.spacing.size.xs} ${theme.v2.static.spacing.size.s}`,
          },
          error: {
            background: "#F8D7DA", //TODO: MISSING TOKEN
            border: `${theme.v2.decoration.border.width.xs} solid ${theme.v2.color.error}`,
          },
          disabledOpacity: 0.4,
        },
        label: {
          fontFamily: theme.v2.typography.bodyText2.family,
          fontSize: theme.v2.typography.bodyText2.size,
          fontWeight: theme.v2.typography.bodyText2.weight,
          color: theme.v2.color.typography.bodyText2,
          fontStyle: "normal",
        },
        removeIcon: {
          color: theme.v2.color.base.grey["700"],
          size: "18px",
          errorColor: theme.v2.color.error,
        },
        errorIcon: {
          color: theme.v2.color.error,
          width: "18px",
          height: "18px",
        },
        leftIcon: {
          color: theme.v2.color.base.grey["700"],
          width: "18px",
          height: "19px",
        },
      },
    };
  }

  getCheckoutRewardSectionProps(_theme) {
    const theme = {
      v2: merge({}, _theme.v2, _theme.v2.overrides.checkoutPromoCodeSection),
    };

    return {
      promotionRow: {
        gap: {
          lg: theme.v2.static.spacing.size.m,
          md: theme.v2.static.spacing.size.m,
          sm: theme.v2.static.spacing.size.m,
        },
        padding: {
          lg: `${theme.v2.static.spacing.size.m} 0px 0px 0px`,
          md: `${theme.v2.static.spacing.size.m} 0px 0px 0px`,
          sm: `${theme.v2.static.spacing.size.m} 0px 0px 0px`,
        },
      },
      infoNotification: {
        root: {
          border: `${theme.v2.decoration.border.width.xs} solid #D9D9D9`, //TODO: missing token
          borderRadius: `${theme.v2.decoration.border.radius.xxs}`,
          padding: `${theme.v2.static.spacing.size.m}`,
          infoBorder: {
            border: `${theme.v2.decoration.border.width.xs} solid ${theme.v2.color.base.grey[500]}`,
            borderWidth: `${theme.v2.decoration.border.width.xs} ${theme.v2.decoration.border.width.xs} ${theme.v2.decoration.border.width.xs} ${theme.v2.decoration.border.width.m}`,
          },
          errorBorder: {
            border: `${theme.v2.decoration.border.width.xs} solid ${theme.v2.color.error}`,
            borderWidth: `${theme.v2.decoration.border.width.xs} ${theme.v2.decoration.border.width.xs} ${theme.v2.decoration.border.width.xs} ${theme.v2.decoration.border.width.m}`,
          },
        },
        icon: {
          sucess: {
            color: "#3EC84C", //success color
          },
          error: {
            color: theme.v2.color.error,
          },
          info: {
            color: theme.v2.color.onSurface,
          },
        },
        title: {
          fontFamily: theme.v2.typography.title1.family,
          fontSize: theme.v2.typography.bodyText2.size,
          fontWeight: theme.v2.typography.title1.weight,
          color: theme.v2.color.typography.bodyText2,
        },
        description: {
          fontFamily: theme.v2.typography.bodyText2.family,
          fontSize: theme.v2.typography.bodyText2.size,
          fontWeight: theme.v2.typography.bodyText2.weight,
          color: theme.v2.color.base.grey["600"],
        },
        action: {
          fontFamily: theme.v2.typography.bodyText2.family,
          fontSize: theme.v2.typography.bodyText2.size,
          fontWeight: theme.v2.typography.bodyText2.weight,
          color: theme.v2.color.typography.bodyText2,
          background: theme.v2.color.background,
          border: `${theme.v2.decoration.border.width.xs} solid #D9D9D9`,
          borderRadius: `${theme.v2.decoration.border.radius.xxs}`,
          padding: `${theme.v2.static.spacing.size.xs}`,
        },
      },
      dropdownSelectInput: {
        placeholder: {
          fontFamily: theme.v2.typography.bodyText2.family,
          fontSize: theme.v2.typography.bodyText2.size,
          fontWeight: theme.v2.typography.bodyText2.weight,
          textTransform: "none",
          color: theme.v2.color.typography.caption1,
        },
        control: {
          height: "46px",
          border: `${theme.v2.decoration.border.width.xs} solid ${theme.v2.color.base.grey["300"]}`,
          borderRadius: theme.v2.decoration.border.radius.xxs,
          hover: {
            border: `${theme.v2.decoration.border.width.xs} solid ${theme.v2.color.base.grey["400"]}`,
          },
          focus: {
            border: `${theme.v2.decoration.border.width.xs} solid ${theme.v2.color.base.grey["300"]}`,
          },
        },
        indicatorSeparator: {
          backgroundColor: theme.v2.color.base.grey["300"],
          width: theme.v2.decoration.border.width.xs,
        },
        input: {
          fontFamily: theme.v2.typography.bodyText2.family,
          fontSize: theme.v2.typography.bodyText2.size,
          fontWeight: theme.v2.typography.bodyText2.weight,
          textTransform: "none",
          color: theme.v2.color.typography.bodyText2,
        },
        menu: {
          fontFamily: theme.v2.typography.bodyText2.family,
          fontSize: theme.v2.typography.bodyText2.size,
          fontWeight: theme.v2.typography.bodyText2.weight,
          textTransform: "none",
          color: theme.v2.color.typography.bodyText2,
          backgroundColor: theme.v2.color.background,
          border: `${theme.v2.decoration.border.width.xs} solid ${theme.v2.color.base.grey["300"]}`,
          borderRadius: theme.v2.decoration.border.radius.xxs,
          boxShadow: "none",
        },
        option: {
          isFocused: {
            color: theme.v2.color.typography.bodyText1,
            backgroundColor: theme.v2.color.base.grey["100"],
          },
          isSelected: {
            color: theme.v2.color.typography.bodyText1,
            backgroundColor: theme.v2.color.base.grey["300"],
          },
        },
      },
      promoTag: {
        container: {
          background: theme.v2.color.base.grey["200"],
          border: "none",
          borderRadius: theme.v2.decoration.border.radius.xxs,
          padding: {
            lg: `${theme.v2.static.spacing.size.xs} ${theme.v2.static.spacing.size.s}`,
            md: `${theme.v2.static.spacing.size.xs} ${theme.v2.static.spacing.size.s}`,
            sm: `${theme.v2.static.spacing.size.xs} ${theme.v2.static.spacing.size.s}`,
          },
          error: {
            background: "#F8D7DA", //TODO: MISSING TOKEN
            border: `${theme.v2.decoration.border.width.xs} solid ${theme.v2.color.error}`,
          },
          disabledOpacity: 0.4,
        },
        label: {
          fontFamily: theme.v2.typography.bodyText2.family,
          fontSize: theme.v2.typography.bodyText2.size,
          fontWeight: theme.v2.typography.bodyText2.weight,
          color: theme.v2.color.typography.bodyText2,
          fontStyle: "normal",
        },
        removeIcon: {
          color: theme.v2.color.base.grey["700"],
          size: "18px",
          errorColor: theme.v2.color.error,
        },
        errorIcon: {
          color: theme.v2.color.error,
          width: "18px",
          height: "18px",
        },
        leftIcon: {
          color: theme.v2.color.base.grey["700"],
          width: "18px",
          height: "19px",
        },
      },
    };
  }

  getCheckoutStepIndicatorProps(_theme) {
    const theme = {
      v2: merge({}, _theme.v2, _theme.v2.overrides?.checkout?.stepIndicator),
    };

    return {
      title: {
        fontFamily: theme.v2.typography.title3.family,
        fontSize: theme.v2.typography.title3.size.lg,
        fontWeight: theme.v2.typography.title3.weight,
        color: theme.v2.color.typography.title3,
      },
      indicator: {
        fontFamily: theme.v2.typography.caption1.family,
        fontSize: theme.v2.typography.caption1.size,
        fontWeight: theme.v2.typography.caption1.weight,
        color: theme.v2.color.typography.caption1,
        selectedColor: theme.v2.color.base.grey["900"],
      },
    };
  }

  getCheckoutContactInfoProps(_theme) {
    const theme = {
      v2: merge({}, _theme.v2, _theme.v2.overrides?.checkout?.contactInfo),
    };

    return {
      title: {
        fontFamily: theme.v2.typography.title4.family,
        fontSize: theme.v2.typography.title4.size.lg,
        fontWeight: theme.v2.typography.title4.weight,
        color: theme.v2.color.typography.title4,
      },
      content: {
        label: {
          fontFamily: theme.v2.typography.bodyText2.family,
          fontSize: theme.v2.typography.bodyText2.size,
          fontWeight: theme.v2.typography.bodyText2.weight,
          color: theme.v2.color.base.grey["600"],
        },
        value: {
          fontFamily: theme.v2.typography.bodyText2.family,
          fontSize: theme.v2.typography.bodyText2.size,
          fontWeight: theme.v2.typography.bodyText2.weight,
          color: theme.v2.color.typography.bodyText2,
          errorColor: theme.v2.color.error,
        },
        actionButton: {
          fontFamily: theme.v2.typography.caption1.family,
          fontSize: theme.v2.typography.caption1.size,
          fontWeight: theme.v2.typography.caption1.weight,
          color: theme.v2.color.base.grey["900"],
          lineHeight: 2,
        },
      },
    };
  }

  getCheckoutDeliveryTypeProps(_theme) {
    const theme = {
      v2: merge({}, _theme.v2, _theme.v2.overrides?.checkout?.deliveryType),
    };

    const borderRadius =
      theme.v2.decoration.border.radius.xxs || theme.v2.decoration.border.radius.default;

    return {
      title: {
        fontFamily: theme.v2.typography.title4.family,
        fontSize: theme.v2.typography.title4.size.lg,
        fontWeight: theme.v2.typography.title4.weight,
        color: theme.v2.color.typography.title4,
      },
      content: {
        optionRow: {
          checkbox: {
            width: "18px",
            height: "18px",
            selectedWidth: "8px",
            selectedHeight: "8px",
            borderRadius: "34px",
            border: "1px solid #D9D9D9",
            selectedBorder: `6px solid ${theme.v2.color.primary}`,
          },
          label: {
            fontFamily: theme.v2.typography.bodyText2.family,
            fontSize: theme.v2.typography.bodyText2.size,
            fontWeight: theme.v2.typography.bodyText2.weight,
            color: theme.v2.color.base.grey["600"],
            selectedColor: theme.v2.color.typography.bodyText2,
            noOptionText: {
              fontFamily: theme.v2.typography.bodyText2.family,
              fontSize: theme.v2.typography.bodyText2.size,
              fontWeight: theme.v2.typography.bodyText2.weight,
              color: theme.v2.color.typography.bodyText2,
            },
          },
          value: {
            fontFamily: theme.v2.typography.bodyText2.family,
            fontSize: theme.v2.typography.bodyText2.size,
            fontWeight: theme.v2.typography.bodyText2.weight,
            color: theme.v2.color.typography.bodyText2,
            selectedColor: theme.v2.color.typography.bodyText2,
          },
          helperText: {
            text: {
              fontFamily: theme.v2.typography.caption1.family,
              fontSize: theme.v2.typography.caption1.size,
              fontWeight: theme.v2.typography.caption1.weight,
              color: theme.v2.color.typography.caption1,
            },
            noOptionText: {
              fontFamily: theme.v2.typography.bodyText2.family,
              fontSize: theme.v2.typography.bodyText2.size,
              fontWeight: theme.v2.typography.bodyText2.weight,
              color: theme.v2.color.typography.bodyText2,
            },
          },
          actionButton: {
            fontFamily: theme.v2.typography.caption1.family,
            fontSize: theme.v2.typography.caption1.size,
            fontWeight: theme.v2.typography.caption1.weight,
            color: theme.v2.color.base.grey["900"],
          },
        },
        error: {
          color: theme.v2.color.error,
        },
        container: {
          border: "1px solid #D9D9D9",
          borderRadius: borderRadius,
          error: {
            border: `1px solid ${theme.v2.color.error}`,
          },
        },
      },
      modal: {
        title: {
          fontFamily: theme.v2.typography.title3.family,
          fontSize: theme.v2.typography.title3.size,
          fontWeight: theme.v2.typography.title3.weight,
          color: theme.v2.color.typography.title3,
        },
        subtitle: {
          fontFamily: theme.v2.typography.title4.family,
          fontSize: theme.v2.typography.title4.size,
          fontWeight: theme.v2.typography.title4.weight,
          color: theme.v2.color.typography.title4,
        },
        helperText: {
          fontFamily: theme.v2.typography.bodyText1.family,
          fontSize: theme.v2.typography.bodyText1.size,
          fontWeight: theme.v2.typography.bodyText1.weight,
          color: theme.v2.color.typography.bodyText1,
        },
        announcement: {
          fontFamily: theme.v2.typography.bodyText1.family,
          fontSize: theme.v2.typography.bodyText1.size,
          fontWeight: theme.v2.typography.bodyText1.weight,
          color: theme.v2.color.typography.bodyText1,
        },
        emptyPlaceholder: {
          subtitle: {
            fontFamily: theme.v2.typography.bodyText2.family,
            fontSize: theme.v2.typography.bodyText2.size,
            fontWeight: theme.v2.typography.bodyText2.weight,
            color: theme.v2.color.typography.bodyText2,
            lineHeight: theme.v2.typography.bodyText2.lineHeight,
          },
          text: {
            fontFamily: theme.v2.typography.caption1.family,
            fontSize: theme.v2.typography.caption1.size,
            fontWeight: theme.v2.typography.caption1.weight,
            color: theme.v2.color.typography.caption1,
            lineHeight: theme.v2.typography.caption1.lineHeight,
          },
        },
        slot: {
          root: {
            fontFamily: theme.v2.typography.bodyText2.family,
            fontSize: theme.v2.typography.bodyText2.size,
            fontWeight: theme.v2.typography.bodyText2.weight,
            color: theme.v2.color.typography.bodyText2,
            textTransform: "none",
            width: "100%",
          },
        },
        confirm: {
          root: {
            fontFamily: theme.v2.typography.title6.family,
            fontSize: theme.v2.typography.title6.size.lg,
            fontWeight: theme.v2.typography.title6.weight,
            borderRadius: theme.v2.decoration.border.radius.xxs,
          },
          primary: {
            backgroundColor: theme.v2.color.primary,
            color: theme.v2.color.onPrimary,
            border: `1px solid ${theme.v2.color.primary}`,
          },
          secondary: {
            backgroundColor: theme.v2.color.onPrimary,
            color: theme.v2.color.primary,
            border: `1px solid ${theme.v2.color.primary}`,
          },
        },
        cancel: {
          root: {
            fontFamily: theme.v2.typography.title6.family,
            fontSize: theme.v2.typography.title6.size.lg,
            fontWeight: theme.v2.typography.title6.weight,
            borderRadius: theme.v2.decoration.border.radius.xxs,
          },
          primary: {
            backgroundColor: theme.v2.color.primary,
            color: theme.v2.color.onPrimary,
            border: `1px solid ${theme.v2.color.primary}`,
          },
          secondary: {
            backgroundColor: theme.v2.color.onPrimary,
            color: theme.v2.color.primary,
            border: `1px solid ${theme.v2.color.primary}`,
          },
        },
        submit: {
          root: {
            fontFamily: theme.v2.typography.title6.family,
            fontSize: theme.v2.typography.title6.size.lg,
            fontWeight: theme.v2.typography.title6.weight,
            borderRadius: theme.v2.decoration.border.radius.xxs,
          },
          primary: {
            backgroundColor: theme.v2.color.primary,
            color: theme.v2.color.onPrimary,
            border: `1px solid ${theme.v2.color.primary}`,
          },
        },
      },
    };
  }

  getCheckoutOrderNotesProps(_theme) {
    const theme = {
      v2: merge({}, _theme.v2, _theme.v2.overrides?.checkout?.orderNotes),
    };

    return {
      title: {
        fontFamily: theme.v2.typography.title4.family,
        fontSize: theme.v2.typography.title4.size.lg,
        fontWeight: theme.v2.typography.title4.weight,
        color: theme.v2.color.typography.title4,
      },
      field: {
        fontFamily: theme.v2.typography.bodyText2.family,
        fontSize: theme.v2.typography.bodyText2.size,
        fontWeight: theme.v2.typography.bodyText2.weight,
        color: theme.v2.color.typography.bodyText2,
        placeholderColor: theme.v2.color.base.grey["600"],
      },
    };
  }

  getCheckoutAdditionalOrderInfoProps(_theme) {
    const theme = {
      v2: merge({}, _theme.v2, _theme.v2.overrides?.checkout?.additionalOrderInfo),
    };

    return {
      additionalInfo: {
        text: {
          fontFamily: get(theme, "v2.typography.caption2.family"),
          fontSize: get(theme, "v2.typography.caption2.size"),
          color: get(theme, "v2.color.base.grey.700"),
          lineHeight: {
            lg: "17px",
            md: "17px",
            sm: "17px",
          },
        },
      },
      legalWarning: {
        text: {
          fontFamily: get(theme, "v2.typography.caption2.family"),
          fontSize: get(theme, "v2.typography.caption2.size"),
          color: get(theme, "v2.color.base.grey.700"),
          lineHeight: {
            lg: "17px",
            md: "17px",
            sm: "17px",
          },
        },
      },
    };
  }

  getCheckoutActionsProps(_theme) {
    const theme = {
      v2: merge({}, _theme.v2, _theme.v2.overrides?.checkout?.actions),
    };

    return {
      button: {
        root: {
          fontFamily: theme.v2.typography.title6.family,
          fontSize: theme.v2.typography.title6.size.lg,
          fontWeight: theme.v2.typography.title6.weight,
          borderRadius: theme.v2.decoration.border.radius.xxs,
          width: "100%",
        },
        primary: {
          backgroundColor: theme.v2.color.primary,
          color: theme.v2.color.onPrimary,
          border: `1px solid ${theme.v2.color.primary}`,
        },
        secondary: {
          backgroundColor: theme.v2.color.onPrimary,
          color: theme.v2.color.primary,
          border: `1px solid ${theme.v2.color.primary}`,
        },
      },
    };
  }

  getPaymentSectionProps(_theme) {
    const theme = {
      v2: merge({}, _theme.v2, _theme.v2.overrides?.checkout?.additionalOrderInfo),
    };

    return {
      title: {
        fontFamily: theme.v2.typography.title4.family,
        fontSize: theme.v2.typography.title4.size.lg,
        fontWeight: theme.v2.typography.title4.weight,
        color: theme.v2.color.typography.title4,
      },
      subtitle: {
        fontFamily: theme.v2.typography.bodyText2.family,
        fontSize: theme.v2.typography.bodyText2.size,
        fontWeight: theme.v2.typography.bodyText2.weight,
        color: theme.v2.color.typography.bodyText2,
      },
      content: {
        optionRow: {
          checkbox: {
            width: "18px",
            height: "18px",
            selectedWidth: "8px",
            selectedHeight: "8px",
            borderRadius: "34px",
            border: "1px solid #D9D9D9",
            selectedBorder: `6px solid ${theme.v2.color.primary}`,
          },
          label: {
            fontFamily: theme.v2.typography.bodyText2.family,
            fontSize: theme.v2.typography.bodyText2.size,
            fontWeight: theme.v2.typography.bodyText2.weight,
            color: theme.v2.color.base.grey["600"],
            selectedColor: theme.v2.color.typography.bodyText2,
          },
        },
      },
    };
  }

  getOrderDetailPaymentModalProps(_theme) {
    const theme = {
      v2: merge({}, _theme.v2, _theme.v2.overrides?.checkout?.orderDetailPaymentModal),
    };

    return {
      modal: {
        content: {
          top: {
            lg: "0px",
            md: "70px",
            sm: "70px",
          },
          translateY: {
            lg: "0",
            md: "0",
            sm: "0",
          },
          maxWidth: {
            lg: "612px",
            md: "100%",
            sm: "100%",
          },
          maxHeight: {
            lg: "100%",
            md: "100%",
            sm: "100%",
          },
          padding: {
            lg: "20px",
            md: "20px",
            sm: "20px 8px",
          },
          borderRadius: {
            lg: "0 0 4px 4px",
            md: "4px 4px 0 0",
            sm: "4px 4px 0 0",
          },
        },
        overlay: {
          color: "#000000",
          opacity: 0.75,
        },
        title: {
          marginTop: theme.v2.static.spacing.m,
          fontFamily: theme.v2.typography.title4.family,
          fontSize: theme.v2.typography.title4.size,
          fontWeight: theme.v2.typography.title4.weight,
          color: theme.v2.color.typography.title4,
        },
        subtitle: {
          fontFamily: theme.v2.typography.bodyText2.family,
          fontSize: theme.v2.typography.bodyText2.size,
          fontWeight: theme.v2.typography.bodyText2.weight,
          color: theme.v2.color.typography.caption1,
        },
        paymentForm: this.getPaymentSectionProps(_theme),
        payButton: {
          root: {
            width: "350px",
          },
        },
      },
    };
  }

  getTipSectionProps(_theme) {
    const theme = _theme.v2;
    const borderRadius =
      theme.decoration.border.radius.xxs || theme.decoration.border.radius.default;

    return {
      root: {
        border: `${theme.decoration.border.width.xs} solid #D9D9D9`,
        borderRadius: borderRadius,
      },
      title: {
        fontFamily: theme.typography.title4.family,
        fontSize: theme.typography.title4.size.lg,
        fontWeight: theme.typography.title4.weight,
        color: theme.color.typography.bodyText2,
      },
      header: {
        border: `${theme.decoration.border.width.xs} solid #D9D9D9`,
        padding: theme.static.spacing.size.m,
        fontFamily: theme.typography.bodyText2.family,
        fontSize: theme.typography.bodyText2.size,
        fontWeight: theme.typography.bodyText2.weight,
        color: theme.color.typography.bodyText2,
      },
      body: {
        backgroundColor: theme.color.base.grey["100"],
        padding: theme.static.spacing.size.m,
      },
      tips: {
        border: `${theme.decoration.border.width.xs} solid #D9D9D9`,
        selectedBorder: `2px solid ${theme.color.primary}`,
        borderRadius: borderRadius,
        backgroundColor: theme.color.background,
        padding: theme.static.spacing.size.s,
        percentage: {
          fontFamily: theme.typography.bodyText2.family,
          fontSize: theme.typography.bodyText2.size,
          fontWeight: theme.typography.bodyText2.weight,
          color: theme.color.typography.bodyText2,
        },
        amount: {
          fontFamily: theme.typography.caption1.family,
          fontSize: theme.typography.caption1.size,
          fontWeight: theme.typography.caption1.weight,
          color: theme.color.typography.caption1,
        },
        noTip: {
          fontFamily: theme.typography.bodyText2.family,
          fontSize: theme.typography.bodyText2.size,
          fontWeight: theme.typography.bodyText2.weight,
          color: theme.color.onSurface,
        },
        customTip: {
          border: `${theme.decoration.border.width.xs} solid #D9D9D9`,
          selectedBorder: `2px solid ${theme.color.primary}`,
          borderRadius: borderRadius,
          backgroundColor: theme.color.background,
          padding: theme.static.spacing.size.s,
          fontFamily: theme.typography.bodyText1.family,
          fontSize: theme.typography.bodyText1.size,
          fontWeight: theme.typography.bodyText1.weight,
          color: theme.color.typography.bodyText1,
        },
      },
      applyButton: {
        backgroundColor: "#000",
        borderRadius: borderRadius,
        padding: "12px 20px",
        fontFamily: theme.typography.bodyText2.family,
        fontSize: theme.typography.bodyText2.size,
        fontWeight: theme.typography.bodyText2.weight,
        color: theme.color.onPrimary,
      },
      footNote: {
        fontFamily: theme.typography.bodyText2.family,
        fontSize: theme.typography.bodyText2.size,
        fontWeight: theme.typography.bodyText2.weight,
        color: theme.color.typography.bodyText2,
      },
    };
  }

  getStrongholdFormProps(_theme) {
    const theme = _theme.v2;

    return {
      container: {
        padding: theme.static.spacing.size.m,
      },
      optionPicker: {
        container: {
          borderRadius: "5px 5px 0px 0px",
          border: "1px solid #D9D9D9",
          alignItems: "start",
        },
        optionRow: {
          row: {
            alignItems: "start",
            gap: {
              lg: "0px",
              md: "0px",
              sm: "0px",
            },
            padding: {
              lg: theme.static.spacing.size.m,
              md: theme.static.spacing.size.m,
              sm: theme.static.spacing.size.m,
            },
            borderRadius: "5px 5px 0px 0px",
          },
          labelContainer: {
            padding: `0px ${theme.static.spacing.size.m} 0px ${theme.static.spacing.size.m};`,
          },
          title: {
            fontFamily: theme.typography.bodyText2.family,
            fontSize: theme.typography.bodyText2.size,
            fontWeight: theme.typography.bodyText2.weight,
            color: theme.color.onSurface,
          },
          subtitle: {
            fontFamily: theme.typography.caption1.family,
            fontSize: theme.typography.caption1.size,
            fontWeight: theme.typography.caption1.weight,
            color: theme.color.typography.caption1,
          },
        },
      },
      linkAccount: {
        backgroundColor: theme.color.surface,
        textAlign: "start",
        textDecoration: "underline",
        border: `1px solid #D9D9D9`,
        borderRadius: "0px 0px 5px 5px",
        padding: theme.static.spacing.size.m,
      },
      emptyPlaceholder: {
        backgroundColor: theme.color.surface,
        border: `1px solid #D9D9D9`,
        borderRadius: "5px 5px 0px 0px",
        padding: theme.static.spacing.size.m,
      },
      emptyPlaceholderTitle: {
        fontFamily: theme.typography.bodyText1.family,
        fontSize: theme.typography.bodyText1.size,
        fontWeight: theme.typography.bodyText1.weight,
        color: theme.color.onSurface,
        marginTop: theme.static.spacing.size.xs,
      },
      emptyPlaceholderSubtitle: {
        fontFamily: theme.typography.caption1.family,
        fontSize: theme.typography.caption1.size,
        fontWeight: theme.typography.caption1.weight,
        color: theme.color.typography.caption1,
      },
    };
  }

  getMerrcoFormProps(_theme) {
    const theme = _theme.v2;

    return {
      container: {
        padding: theme.static.spacing.size.m,
      },
      creditCardPanel: {
        optionPicker: {
          container: {
            borderRadius: `${theme.decoration.border.radius.xxs} ${theme.decoration.border.radius.xxs} 0px 0px`,
            border: `${theme.decoration.border.width.xs} solid #D9D9D9`,
            alignItems: "start",
          },
          optionRow: {
            row: {
              gap: {
                lg: theme.static.spacing.size.xs,
                md: theme.static.spacing.size.xs,
                sm: theme.static.spacing.size.xs,
              },
              padding: {
                lg: theme.static.spacing.size.m,
                md: theme.static.spacing.size.m,
                sm: theme.static.spacing.size.m,
              },
              borderRadius: `${theme.decoration.border.radius.xxs} ${theme.decoration.border.radius.xxs} 0px 0px`,
              lastChildRadius: `0px 0px ${theme.decoration.border.radius.xxs} ${theme.decoration.border.radius.xxs}`,
            },
            labelContainer: {
              padding: `0px`,
            },
            label: {
              fontFamily: theme.typography.bodyText2.family,
              fontSize: theme.typography.bodyText2.size,
              fontWeight: theme.typography.bodyText2.weight,
              color: theme.color.onSurface,
              textTransform: "none",
            },
            title: {
              fontFamily: theme.typography.bodyText2.family,
              fontSize: theme.typography.bodyText2.size,
              fontWeight: theme.typography.bodyText2.weight,
              color: theme.color.onSurface,
              expired: {
                color: theme.color.base.grey[500],
              },
            },
            subtitle: {
              fontFamily: theme.typography.caption1.family,
              fontSize: theme.typography.caption1.size,
              fontWeight: theme.typography.caption1.weight,
              color: theme.color.typography.caption1,
              expired: {
                color: theme.color.error,
              },
            },
          },
        },
        newCreditCardForm: {
          gap: theme.static.spacing.size.m,
          error: {
            fontFamily: theme.typography.caption1.family,
            fontSize: theme.typography.caption1.size,
            fontWeight: theme.typography.caption1.weight,
            color: theme.color.error,
            lineHeight: "150%",
            letterSpacing: "-0.2px",
          },
          input: {
            fontFamily: theme.typography.bodyText2.family,
            fontSize: theme.typography.bodyText2.size,
            fontWeight: theme.typography.bodyText2.weight,
            background: theme.color.background,
            border: `${theme.decoration.border.width.xs} solid #D9D9D9`,
            borderRadius: theme.decoration.border.radius.xxs,
            placeholderColor: "#737373",
            padding: {
              lg: theme.static.spacing.size.s,
              md: theme.static.spacing.size.s,
              sm: theme.static.spacing.size.s,
            },
            hover: {
              borderColor: "hsl(0, 0%, 70%)",
            },
            error: {
              border: `${theme.decoration.border.width.xs} solid ${theme.color.error}`,
              placeholderColor: theme.color.error,
            },
            disabled: {
              background: "hsl(0, 0%, 95%)",
              border: `${theme.decoration.border.width.xs} solid #D9D9D9`,
            },
          },
        },
      },
    };
  }

  getMonerisFormProps(_theme) {
    const theme = _theme.v2;

    return {
      container: {
        padding: theme.static.spacing.size.m,
      },
      iframe: {
        height: "92px",
      },
      bodyCss: `
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: normal;
        align-items: normal;
        align-content: normal;
        gap: ${theme.static.spacing.size.xs};
        height: fit-content;
      `,
      textBoxCss: `
        width: 100%;
        height: fit-content;
        flex-grow: 1;
        padding: ${theme.static.spacing.size.s};
        border-radius: ${theme.decoration.border.radius.xxs};
        border: 1px solid #D9D9D9;
        font-family: ${theme.typography.bodyText2.family};
        font-size: ${theme.typography.bodyText2.size.lg};
        font-weight: ${theme.typography.caption1.weight};
        color: ${theme.color.onSurface};
      `,
      expTextBoxCss: `
        width: 60%;
      `,
      cvcTextBoxCss: `
        width: 30%;
      `,
    };
  }

  getOrderDetailProps(_theme) {
    const theme = {
      v2: merge({}, _theme.v2, _theme.v2.overrides.orderDetail),
    };

    return {
      shop: {
        fontFamily: theme.v2.typography.title2.family,
        fontSize: theme.v2.typography.title2.size,
        fontWeight: theme.v2.typography.title2.weight,
        color: theme.v2.color.typography.title2,
      },
      header: {
        icon: {
          color: theme.v2.color.onSurface,
        },
        topText: {
          fontFamily: theme.v2.typography.bodyText2.family,
          fontSize: theme.v2.typography.bodyText2.size,
          fontWeight: theme.v2.typography.bodyText2.weight,
          color: theme.v2.color.base.grey["700"],
        },
        customerName: {
          fontFamily: theme.v2.typography.title4.family,
          fontSize: theme.v2.typography.title4.size,
          fontWeight: theme.v2.typography.title4.weight,
          color: theme.v2.color.typography.title4,
        },
      },
      order: {
        root: {
          border: `${theme.v2.decoration.border.width.xs} solid #D9D9D9`,
          borderRadius: `${theme.v2.decoration.border.radius.xxs}`,
          padding: `${theme.v2.static.spacing.size.m}`,
        },
        title: {
          fontFamily: theme.v2.typography.title4.family,
          fontSize: theme.v2.typography.title4.size,
          fontWeight: theme.v2.typography.title4.weight,
          color: theme.v2.color.typography.title4,
        },
        info: {
          fontFamily: theme.v2.typography.bodyText2.family,
          fontSize: theme.v2.typography.bodyText2.size,
          fontWeight: theme.v2.typography.bodyText2.weight,
          color: theme.v2.color.base.grey["700"],
        },
        states: {
          selectedColor: theme.v2.color.onSurface,
        },
        label: {
          fontFamily: theme.v2.typography.title6.family,
          fontSize: theme.v2.typography.title6.size,
          fontWeight: theme.v2.typography.title6.weight,
          color: theme.v2.color.typography.title6,
        },
      },
      customer: {
        root: {
          border: `${theme.v2.decoration.border.width.xs} solid #D9D9D9`,
          borderRadius: `${theme.v2.decoration.border.radius.xxs}`,
          padding: `${theme.v2.static.spacing.size.m}`,
        },
        title: {
          fontFamily: theme.v2.typography.title4.family,
          fontSize: theme.v2.typography.title4.size,
          fontWeight: theme.v2.typography.title4.weight,
          color: theme.v2.color.typography.title4,
        },
        info: {
          title: {
            fontFamily: theme.v2.typography.bodyText2.family,
            fontSize: theme.v2.typography.bodyText2.size,
            fontWeight: theme.v2.typography.bodyText2.weight,
            color: theme.v2.color.typography.bodyText2,
          },
          text: {
            fontFamily: theme.v2.typography.bodyText2.family,
            fontSize: theme.v2.typography.bodyText2.size,
            fontWeight: theme.v2.typography.bodyText2.weight,
            color: theme.v2.color.base.grey["700"],
          },
        },
        saveInfo: {
          root: {
            fontFamily: theme.v2.typography.bodyText2.family,
            fontSize: theme.v2.typography.bodyText2.size,
            fontWeight: theme.v2.typography.bodyText2.weight,
            color: theme.v2.color.base.grey["700"],
          },
        },
      },
      paymentInfo: {
        root: {
          border: `${theme.v2.decoration.border.width.xs} solid #D9D9D9`,
          borderRadius: `${theme.v2.decoration.border.radius.xxs}`,
          padding: `${theme.v2.static.spacing.size.m}`,
        },
        title: {
          fontFamily: theme.v2.typography.title4.family,
          fontSize: theme.v2.typography.title4.size,
          fontWeight: theme.v2.typography.title4.weight,
          color: theme.v2.color.typography.title4,
        },
        info: {
          title: {
            fontFamily: theme.v2.typography.bodyText2.family,
            fontSize: theme.v2.typography.bodyText2.size,
            fontWeight: theme.v2.typography.bodyText2.weight,
            color: theme.v2.color.typography.bodyText2,
          },
          text: {
            fontFamily: theme.v2.typography.bodyText2.family,
            fontSize: theme.v2.typography.bodyText2.size,
            fontWeight: theme.v2.typography.bodyText2.weight,
            color: theme.v2.color.base.grey["700"],
          },
        },
        paymentTitle: {
          fontFamily: theme.v2.typography.bodyText2.family,
          fontSize: theme.v2.typography.bodyText2.size,
          fontWeight: theme.v2.typography.bodyText2.weight,
          color: theme.v2.color.typography.bodyText2,
        },
        paymentSubtitle: {
          fontFamily: theme.v2.typography.caption1.family,
          fontSize: theme.v2.typography.caption1.size,
          fontWeight: theme.v2.typography.caption1.weight,
          color: theme.v2.color.typography.caption1,
        },
        paymentDate: {
          fontFamily: theme.v2.typography.caption1.family,
          fontSize: theme.v2.typography.caption1.size,
          fontWeight: theme.v2.typography.caption1.weight,
          color: theme.v2.color.typography.caption1,
        },
        paymentError: {
          fontFamily: theme.v2.typography.caption1.family,
          fontSize: theme.v2.typography.caption1.size,
          fontWeight: theme.v2.typography.caption1.weight,
          color: theme.v2.color.error,
        },
      },
      infoNotification: {
        root: {
          border: `${theme.v2.decoration.border.width.xs} solid #D9D9D9`, //TODO: missing token
          borderRadius: `${theme.v2.decoration.border.radius.xxs}`,
          padding: `${theme.v2.static.spacing.size.m}`,
          infoBorder: {
            border: `${theme.v2.decoration.border.width.xs} solid ${theme.v2.color.base.grey[500]}`,
            borderWidth: `${theme.v2.decoration.border.width.xs} ${theme.v2.decoration.border.width.xs} ${theme.v2.decoration.border.width.xs} ${theme.v2.decoration.border.width.m}`,
          },
          errorBorder: {
            border: `${theme.v2.decoration.border.width.xs} solid ${theme.v2.color.error}`,
            borderWidth: `${theme.v2.decoration.border.width.xs} ${theme.v2.decoration.border.width.xs} ${theme.v2.decoration.border.width.xs} ${theme.v2.decoration.border.width.m}`,
          },
        },
        icon: {
          sucess: {
            color: "#3EC84C", //success color
          },
          error: {
            color: theme.v2.color.error,
          },
          info: {
            color: theme.v2.color.onSurface,
          },
        },
        title: {
          fontFamily: theme.v2.typography.title1.family,
          fontSize: theme.v2.typography.bodyText2.size,
          fontWeight: theme.v2.typography.title1.weight,
          color: theme.v2.color.typography.bodyText2,
        },
        description: {
          fontFamily: theme.v2.typography.bodyText2.family,
          fontSize: theme.v2.typography.bodyText2.size,
          fontWeight: theme.v2.typography.bodyText2.weight,
          color: theme.v2.color.typography.bodyText2,
        },
        action: {
          fontFamily: theme.v2.typography.bodyText2.family,
          fontSize: theme.v2.typography.bodyText2.size,
          fontWeight: theme.v2.typography.bodyText2.weight,
          color: theme.v2.color.typography.bodyText2,
          background: theme.v2.color.background,
          border: `${theme.v2.decoration.border.width.xs} solid #D9D9D9`,
          borderRadius: `${theme.v2.decoration.border.radius.xxs}`,
          padding: `${theme.v2.static.spacing.size.xs}`,
        },
      },
      supportInfo: {
        root: {
          border: `${theme.v2.decoration.border.width.xs} solid #D9D9D9`,
          borderRadius: `${theme.v2.decoration.border.radius.xxs}`,
          padding: `${theme.v2.static.spacing.size.m}`,
        },
        title: {
          fontFamily: theme.v2.typography.title4.family,
          fontSize: theme.v2.typography.title4.size,
          fontWeight: theme.v2.typography.title4.weight,
          color: theme.v2.color.typography.title4,
        },
        info: {
          fontFamily: theme.v2.typography.bodyText1.family,
          fontSize: theme.v2.typography.bodyText1.size,
          fontWeight: theme.v2.typography.bodyText1.weight,
          color: theme.v2.color.typography.bodyText1,
        },
      },
    };
  }

  getCheckoutErrorsProps(_theme) {
    const theme = {
      v2: merge({}, _theme.v2, _theme.v2.overrides?.checkout?.errors),
    };

    return {
      title: {
        fontFamily: theme.v2.typography.bodyText2.family,
        fontSize: theme.v2.typography.bodyText2.size,
        fontWeight: theme.v2.typography.title2.weight,
        color: theme.v2.color.typography.bodyText2,
      },
      description: {
        fontFamily: theme.v2.typography.bodyText2.family,
        fontSize: theme.v2.typography.bodyText2.size,
        fontWeight: theme.v2.typography.bodyText2.weight,
        color: theme.v2.color.typography.bodyText2,
      },
    };
  }

  getInStoreProps(_theme) {
    const theme = {v2: merge({}, _theme.v2, _theme.v2.overrides?.inStore)};

    return {
      root: {
        backgroundColor: theme.v2.color.primary,
        fontFamily: theme.v2.typography.bodyText2.family,
        color: theme.v2.color.onPrimary,
        mainTextFontSize: theme.v2.typography.bodyText1.size,
        secondaryTextFontSize: theme.v2.typography.bodyText2.size,
        mainTextFontWeight: theme.v2.typography.bodyText1.weight,
        secondaryTextFontWeight: theme.v2.typography.bodyText2.weight,
        mainTextColor: theme.v2.color.base.grey["900"],
        secondaryTextColor: theme.v2.color.base.grey["700"],
        titleFontSize: theme.v2.typography.title4.size,
        titleFontWeight: theme.v2.typography.title4.weight,
        subtitleFontSize: theme.v2.typography.bodyText1.size,
        subtitleFontWeight: theme.v2.typography.bodyText1.weight,
      },
      button: {
        backgroundColor: theme.v2.color.primary,
        color: theme.v2.color.onPrimary,
        borderRadius: theme.v2.decoration.border.radius.default,
        fontWeight: theme.v2.typography.title5.weight,
      },
      menuButton: {
        backgroundColor: theme.v2.color.surface,
        color: theme.v2.color.base.grey["800"],
      },
    };
  }

  getSearchProps(_theme) {
    const theme = {v2: merge({}, _theme.v2, _theme.v2.overrides?.appBar?.search)};

    return {
      root: {
        backgroundColor: theme.v2.color.secondary,
      },
      searchBar: {
        root: {
          padding: {
            lg: 0,
            md: 0,
            sm: 0,
          },
        },
        input: {
          backgroundColor: theme.v2.color.surface,
          borderRadius: theme.v2.decoration.border.radius.xs,
          border: `1px solid ${theme.v2.color.onSecondary}`,
          fontFamily: theme.v2.typography.bodyText1.family,
          fontWeight: theme.v2.typography.bodyText1.weight,
          fontSize: theme.v2.typography.bodyText1.size,
          color: theme.v2.color.typography.bodyText1,
          placeholder: {
            color: theme.v2.color.typography.bodyText1,
          },
          searchIcon: {
            color: theme.v2.color.base.grey[600],
          },
        },
        close: {
          color: theme.v2.color.onSecondary,
        },
      },
      searchPanel: {
        root: {
          backgroundColor: theme.v2.color.secondary,
        },
        groupName: {
          fontFamily: theme.v2.typography.title4.family,
          fontWeight: theme.v2.typography.title4.weight,
          fontSize: theme.v2.typography.title4.size,
          color: theme.v2.color.typography.onSecondary,
        },
        image: {
          borderRadius: theme.v2.decoration.border.radius.xs,
        },
        title: {
          fontFamily: theme.v2.typography.title6.family,
          fontWeight: theme.v2.typography.title6.weight,
          fontSize: theme.v2.typography.title6.size,
          color: theme.v2.color.typography.onSecondary,
        },
        description: {
          fontFamily: theme.v2.typography.caption1.family,
          fontWeight: theme.v2.typography.caption1.weight,
          fontSize: theme.v2.typography.caption1.size,
          color: theme.v2.color.onSecondary,
        },
        seeAll: {
          fontFamily: theme.v2.typography.caption1.family,
          fontWeight: theme.v2.typography.caption1.weight,
          fontSize: theme.v2.typography.caption1.size,
          color: theme.v2.color.onSecondary,
        },
      },
      searchPage: {
        header: {
          fontFamily: theme.v2.typography.title6.family,
          fontWeight: theme.v2.typography.title6.weight,
          fontSize: theme.v2.typography.title6.size,
          color: theme.v2.color.onSecondary,
        },
        tabs: {
          tab: {
            fontFamily: theme.v2.typography.title5.family,
            fontWeight: theme.v2.typography.title5.weight,
            fontSize: {
              lg: theme.v2.typography.title5.size.lg,
              md: theme.v2.typography.title5.size.md,
              sm: "14px",
            },
            color: theme.v2.color.typography.onBackground,
            border: `3px solid ${theme.v2.color.secondary}`,
            buttonSelectedBackgroundColor: theme.v2.color.primary,
            buttonSelectedColor: theme.v2.color.onPrimary,
            buttonBorder: `1px solid ${theme.v2.color.primary}`,
          },
          separator: {
            color: theme.v2.color.base.grey["200"],
          },
        },
        results: {
          fontFamily: theme.v2.typography.bodyText2.family,
          fontWeight: theme.v2.typography.bodyText2.weight,
          fontSize: theme.v2.typography.bodyText2.size,
          color: theme.v2.color.typography.onBackground,
        },
        sort: {
          label: {
            fontFamily: theme.v2.typography.bodyText2.family,
            fontWeight: theme.v2.typography.bodyText2.weight,
            fontSize: theme.v2.typography.bodyText2.size,
            color: theme.v2.color.typography.onBackground,
          },
        },
        groupedProductsList: {
          elementsPerRow: {
            lg: 4,
            md: 3,
            sm: 1,
          },
        },
      },
    };
  }
}
